import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import Sketch from 'react-p5';
import { setup, draw, usePlinkoGame } from './Plinko';
import './Games.css';
import './Plinko.css';

const PlinkoGame = () => {
  const navigate = useNavigate();
  const {
    user,
    betDenominations,
    handleBet,
    message,
  } = usePlinkoGame();

  return (
    <div className="page">
      <div className="page-container">
        <div className="plinko-game">
          <div className="back-button-container">
            <FaArrowLeft className="back-button" onClick={() => navigate(-1)} />
          </div>
          <div className="game-header">
            <h2>Plinko</h2>
            {user && <p className="player-balance">Balance: 💴 {user.money.toFixed(2)}</p>}
          </div>
          <div className="betting-controls">
            <div className="bet-buttons">
              {betDenominations.map((amount, index) => (
                <div
                  key={index}
                  className={`chip chip-${amount}`}
                  onClick={() => handleBet(amount)}
                >
                  <span>{amount}</span>
                </div>
              ))}
            </div>
          </div>
          <Sketch setup={setup} draw={draw} />
          {message && <div className="message">{message}</div>}
        </div>
      </div>
    </div>
  );
};

export default PlinkoGame;
